(() => {
  if (window.bvSizeGuideLoaded) return;
  window.bvSizeGuideLoaded = true;

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-bv-size-guide-open]');
    if (opener) {
      document.getElementById(`bv-size-guide-${opener.dataset.bvSizeGuideOpen}`)?.showModal();
      return;
    }
    const closer = event.target.closest('[data-bv-size-guide-close]');
    if (closer) closer.closest('dialog')?.close();
  });

  document.addEventListener('click', (event) => {
    if (event.target.matches('dialog.bv-size-guide')) event.target.close();
  });
})();
